export const TEMPLATES_FILTER = {
  $search: undefined,
  $scope: [ 'full' ],
  type: undefined,
  OwnerId: undefined,
  id: undefined
}
